import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { CmpPersistAlertObject, PersistAlertType } from '../objects/persist-alert.object';

@Injectable()
export class PersistAlertService {
    public alerts: Array<CmpPersistAlertObject> = [];
    public openAlerts: Array<{changed: boolean, alert: CmpPersistAlertObject}> = [];
    private subject = new Subject<CmpPersistAlertObject | null>();

    constructor(
        private router: Router
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.clear();
            }
        });

        this.subject.asObservable().subscribe((alert: CmpPersistAlertObject | null) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            // add alert to array
            this.alerts.push(alert);
        });
    }

    public getOpenAlerts(): Array<{changed: boolean, alert: CmpPersistAlertObject}> {
        const newOpenAlerts = this.updateAndFilterOpenAlerts();
        if (
            newOpenAlerts.length !== this.openAlerts.length ||
            newOpenAlerts.some((alert: {changed: boolean, alert: CmpPersistAlertObject}) => alert.changed)
        ) {
            this.openAlerts = newOpenAlerts;
        }

        return this.openAlerts;
    }

    private updateAndFilterOpenAlerts(): Array<{changed: boolean, alert: CmpPersistAlertObject}> {
        return this.alerts
            .map((alert: CmpPersistAlertObject) => alert.update())
            .filter((alert: {changed: boolean, alert: CmpPersistAlertObject}) => alert.alert.isOpen);
    }

    public message(title: string|(()=>string), message: string|(()=>string), type: PersistAlertType|(()=>PersistAlertType) = 'success'): CmpPersistAlertObject {
        let alert: CmpPersistAlertObject = CmpPersistAlertObject.create(type, title, message);
        this.subject.next(alert);
        return alert;
    }

    public clear() {
        this.subject.next(null);
    }
}
